import {
  CreateMetaResponse,
  GalleryPostVM,
  UpdateVideos,
  UploadUrlRequest,
  UploadUrlResponse,
  VideoResolve,
  Videos,
  VideosVM
} from '@/models'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
const blobHttp = axios.create({
  withCredentials: false // important: do not send cookies cross-origin
})
const API_URL = 'Gallery'
import store from '@/store'

export const postVideo = async (
  model: GalleryPostVM
): Promise<GalleryPostVM[]> => {
  const { data } = await axios.post(API_URL + '/Upload', model)
  return data
}
export const getGallery = async (
  pageNumber = 1,
  pageSize = 10,
  searchQuery = ''
): Promise<AxiosResponse<Videos[]>> => {
  //console.log(API_URL)
  const response = await axios.get(
    API_URL +
      '/Gallery' +
      `?pageNumber=${pageNumber}&pageSize=${pageSize}&SearchQuery=${searchQuery}`
  )
  return response
}
// gallery.service.ts
// import axios from 'axios'
// import http from '@/http' // your configured axios instance for API (with token)

export async function createGalleryVideoMeta(payload: any) {
  // This must return { id: number }
  // Use your existing endpoint, but change backend to return the new id.
  const res = await axios.post(API_URL + '/Upload', payload)
  return res.data // { id }
}

export async function getUploadUrl(
  videoId: number,
  contentType: string,
  sasMinutes = 15
): Promise<UploadUrlResponse> {
  const body: UploadUrlRequest = {
    contentType,
    sasMinutes
  }

  const res = await axios.post<UploadUrlResponse>(
    API_URL + `/GalleryVideo/${videoId}/upload-url`,
    body
  )
  return res.data
}

export async function putBlob(
  uploadUrl: string,
  file: File,
  onProgress: (pct: number) => void
) {
  await blobHttp.put(uploadUrl, file, {
    headers: {
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': file.type || 'video/mp4'
    },
    timeout: 0,
    onUploadProgress: e => {
      if (!e.total) return
      const pct = Math.round((e.loaded * 100) / e.total)
      onProgress(pct)
    }
  })
}
export async function uploadVideoToBlob(
  uploadUrl: string,
  file: File,
  onProgress?: (pct: number) => void
): Promise<void> {
  const cfg: AxiosRequestConfig = {
    headers: {
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': file.type || 'video/mp4'
    },
    timeout: 0,
    onUploadProgress: evt => {
      if (!onProgress || !evt.total) return
      const pct = Math.round((evt.loaded * 100) / evt.total)
      onProgress(pct)
    }
  }

  // IMPORTANT: use raw axios here (no baseURL), because uploadUrl is absolute (Blob URL)
  await axios.put(uploadUrl, file, cfg)
}
export async function createGalleryMeta(
  payload: GalleryPostVM
): Promise<CreateMetaResponse> {
  const res = await axios.post<CreateMetaResponse>(API_URL + '/Upload', payload)
  return res.data
}
export async function createAndUploadVideo(
  payload: GalleryPostVM,
  file: File,
  onProgress?: (pct: number) => void
): Promise<{ videoId: number; videoPath: string }> {
  // 1) Create DB record and get ID
  const created = await createGalleryMeta(payload)
  const videoId = created.id

  // 2) Get SAS upload URL
  const sas = await getUploadUrl(videoId, file.type || 'video/mp4', 15)

  // 3) Upload bytes
  await uploadVideoToBlob(sas.uploadUrl, file, onProgress)

  // 4) Your canonical DB path for playback via CDN
  const videoPath = `/gallery/${videoId}.mp4`

  return { videoId, videoPath }
}
export const getVideoResolve = async (
  id: number,
  pageNumber = 1,
  pageSize = 10,
  searchQuery = ''
): Promise<VideoResolve> => {
  const { data } = await axios.get(
    API_URL +
      '/GalleryResolve' +
      `?videoID=${id}&pageNumber=${pageNumber}&pageSize=${pageSize}&SearchQuery=${searchQuery}`
  )
  return data
}

export const getVideoFile = async (): Promise<any> => {
  const data = await axios.get('http://localhost:8000/video?id=1', {
    headers: {
      Range: 'bytes=0-'
    }
  })
  return data
}
export const deleteVideo = async (video: VideosVM): Promise<any> => {
  const { data } = await axios.put<any>(API_URL + `/DeleteVideo`, video)
  return data
}
export const updateVideo = async (video: UpdateVideos): Promise<any> => {
  const { data } = await axios.put<any>(API_URL + `/UpdateVideo`, video)
  return data
}
// export const upload = async (): Promise<any> => {
//   const { data } = await axios.put<any>(API_URL + `/UpdateVideo`, video)
//   return data
// }
export interface PlayUrlResponse {
  url: string
  expiresMinutes?: number
}

export async function getVideoPlayUrl(
  videoId: string
): Promise<PlayUrlResponse> {
  const { data } = await axios.get<PlayUrlResponse>(
    API_URL + `/GalleryVideo/${videoId}/play`
  )
  return data
}
export const uploadFile = async (file: FormData): Promise<any> => {
  const config = {
    onUploadProgress: (progressEvent: ProgressEvent) =>
      // console.log(progressEvent.loaded)
      store.dispatch(
        'app/addProgress',
        (progressEvent.loaded / progressEvent.total) * 100
      )
  }
  const { data } = await axios.post(API_URL + `/UploadFile`, file, config)
  return data
}
